/*
  sdx-attribution.js — kampanya kaynağını sepet özelliğine yazar (Colorbox cbx-attribution.js v2 portu).

  URL'deki utm_* ve tıklama kimliklerini (gclid, fbclid vb.) okur, sipariş kaydına taşır:
  - __atif_ilk : ilk temas (source/medium/campaign + tıklama-id)
  - __atif_son : son GERÇEK temas (self-referral/ödeme HARİÇ)
  - __atif_yol : tüm kaynak-taşıyan ziyaretlerin dizisi (ilk → son), JSON — sipariş bazında
                 yolculuk + en etkili kampanya analizi için (custom.atif_yol metafield'ına kopyalanır)

  - `__` önekli özellikler müşteriye gösterilmez.
  - İlk temas korunur, son temas güncellenir; iç gezinme son temmasını ezmez.
  - Self-referral (shopify.com Shop Pay / PayTR / iyzico ödeme, sidrex alt alan adları) kaynak SAYILMAZ
    — son-tık atfını çalar.
  - /cart/update.js yalnız değer ya da SEPET değiştiğinde çağrılır (sipariş sonrası açılan yeni sepete
    atıf yeniden yazılır; aksi halde 2. sipariş 'doğrudan' görünürdü).
*/
(function () {
  'use strict';

  var DEPO = 'sdx_atif_v1';
  var OMUR_GUN = 90;
  var MAX_YOL = 12;                                  // yolculuk dizisi üst sınırı
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  var TIK = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid', 'srsltid', 'twclid'];
  var KAMPANYA_ID = ['gad_campaignid', 'gad_source'];
  var HARIC = /(^|\.)shopify\.com$|paytr|iyzico|iyzipay/i;  // self-referral / ödeme — kaynak SAYMA

  /* Kendi alan adımız (www/checkout alt alan adları dahil) kaynak değildir. */
  function kendiAlanAdi(host) {
    var kok = window.location.host.replace(/^www\./, '');
    return host === kok || host.slice(-(kok.length + 1)) === '.' + kok;
  }

  /* Tarayıcıdaki sepet kimliği (Shopify `cart` çerezi, ?key= kısmı hariç). Sepet yoksa ''. */
  function sepetKimligi() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]).split('?')[0]; } catch (e) { return m[1].split('%3F')[0]; }
  }

  function guvenliDepo() {
    try {
      var t = '__sdx_t';
      window.localStorage.setItem(t, '1');
      window.localStorage.removeItem(t);
      return window.localStorage;
    } catch (e) { return null; }
  }

  function oku(depo) {
    if (!depo) return null;
    try {
      var ham = depo.getItem(DEPO);
      if (!ham) return null;
      var v = JSON.parse(ham);
      if (!v || !v.ilk) return null;
      if (v.ilk.ts && (Date.now() - v.ilk.ts) > OMUR_GUN * 864e5) return null;
      return v;
    } catch (e) { return null; }
  }

  function yaz(depo, v) {
    if (!depo) return;
    try { depo.setItem(DEPO, JSON.stringify(v)); } catch (e) { /* kota — sessiz geç */ }
  }

  /* Mevcut URL'den bir "temas" nesnesi çıkarır. Kaynak sinyali yoksa null döner. */
  function temasCikar() {
    var p;
    try { p = new URL(window.location.href).searchParams; } catch (e) { return null; }

    var t = { ts: Date.now() };
    var sinyalVar = false;

    UTM.forEach(function (k) {
      var v = p.get(k);
      if (v) { t[k.replace('utm_', '')] = v.slice(0, 120); sinyalVar = true; }
    });
    TIK.forEach(function (k) {
      var v = p.get(k);
      if (v) { t[k] = v.slice(0, 200); sinyalVar = true; }
    });
    KAMPANYA_ID.forEach(function (k) {
      var v = p.get(k);
      if (v) { t[k] = v.slice(0, 60); sinyalVar = true; }
    });

    // Tıklama kimliği/UTM yoksa DIŞ yönlendireni kaynak say — self-referral/ödeme HARİÇ
    if (!sinyalVar) {
      var ref = document.referrer || '';
      if (ref) {
        var rh = '';
        try { rh = new URL(ref).host; } catch (e) { rh = ''; }
        if (rh && !kendiAlanAdi(rh) && !HARIC.test(rh)) {
          t.ref = rh.slice(0, 120);
          sinyalVar = true;
        }
      }
    }

    if (!sinyalVar) return null;
    try { t.lp = window.location.pathname.slice(0, 160); } catch (e) { /* yoksay */ }
    return t;
  }

  /* Sepet özelliği kompakt string (ilk/son) */
  function duzlestir(t) {
    if (!t) return '';
    var parca = [];
    ['source', 'medium', 'campaign', 'content', 'term', 'id'].forEach(function (k) {
      if (t[k]) parca.push(k + '=' + t[k]);
    });
    TIK.concat(KAMPANYA_ID).forEach(function (k) { if (t[k]) parca.push(k + '=' + t[k]); });
    if (t.ref) parca.push('ref=' + t.ref);
    if (t.lp) parca.push('lp=' + t.lp);
    if (t.ts) parca.push('ts=' + new Date(t.ts).toISOString().slice(0, 19) + 'Z');
    return parca.join('|').slice(0, 900);
  }

  /* Dedup anahtarı — yalnız KAYNAK sinyalleri (ts + lp HARİÇ) → aynı kaynağın tekrarı churn yapmaz */
  function kaynakAnahtar(t) {
    if (!t) return '';
    var parca = [];
    ['source', 'medium', 'campaign', 'content', 'term', 'id'].forEach(function (k) {
      if (t[k]) parca.push(k + '=' + t[k]);
    });
    TIK.concat(KAMPANYA_ID).forEach(function (k) { if (t[k]) parca.push(k + '=' + t[k]); });
    if (t.ref) parca.push('ref=' + t.ref);
    return parca.join('|');
  }

  /* Yolculuk dizisi için LEAN temas — source/medium/campaign KESİN + birincil tıklama-id + ts */
  function yolTemas(t) {
    var o = {};
    if (t.source) o.s = t.source;
    if (t.medium) o.m = t.medium;
    if (t.campaign) o.c = t.campaign;
    for (var i = 0; i < TIK.length; i++) {
      if (t[TIK[i]]) { o.tik = TIK[i]; o.tikv = String(t[TIK[i]]).slice(0, 60); break; }
    }
    if (t.gad_campaignid) o.cid = t.gad_campaignid;
    if (t.ref) o.ref = t.ref;
    if (t.lp) o.lp = t.lp;
    if (t.ts) o.ts = new Date(t.ts).toISOString().slice(0, 19) + 'Z';
    return o;
  }

  function sepeteYaz(ilkStr, sonStr, yolJson) {
    var govde = { attributes: {} };
    govde.attributes['__atif_ilk'] = ilkStr;
    govde.attributes['__atif_son'] = sonStr;
    govde.attributes['__atif_yol'] = yolJson;
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(govde)
    });
  }

  function calistir() {
    var depo = guvenliDepo();
    var kayit = oku(depo) || {};
    if (!Array.isArray(kayit.yol)) kayit.yol = [];
    var degisti = false;

    // v1→v2 tohumlama: eski JS ilk/son yazmış ama yol boşsa, yolu ilk(+son)'dan kur
    // (v1'den dönen müşteride tam yolculuk korunur; aksi halde yol boş kalırdı).
    if (kayit.yol.length === 0 && kayit.ilk) {
      kayit.yol.push(kayit.ilk);
      if (kayit.son && kaynakAnahtar(kayit.son) !== kaynakAnahtar(kayit.ilk)) {
        kayit.yol.push(kayit.son);
      }
      degisti = true;
    }

    var yeni = temasCikar();

    if (yeni) {
      if (!kayit.ilk) { kayit.ilk = yeni; degisti = true; }
      var yeniAnahtar = kaynakAnahtar(yeni);
      var oncekiSonAnahtar = kayit.son ? kaynakAnahtar(kayit.son) : '';
      // son temas: yalnız GERÇEKTEN farklı bir kaynak geldiyse güncelle (ts churn'ü değil)
      if (yeniAnahtar !== oncekiSonAnahtar) {
        kayit.son = yeni;
        degisti = true;
        // yol'a ekle (ardışık aynı kaynağı tekrar ekleme)
        var sonYolAnahtar = kayit.yol.length ? kaynakAnahtar(kayit.yol[kayit.yol.length - 1]) : '';
        if (yeniAnahtar !== sonYolAnahtar) {
          kayit.yol.push(yeni);
          if (kayit.yol.length > MAX_YOL) {
            // ilk teması KORU + son (MAX_YOL-1) temas
            kayit.yol = [kayit.yol[0]].concat(kayit.yol.slice(kayit.yol.length - (MAX_YOL - 1)));
          }
        }
      }
    }

    if (!kayit.ilk) return; // hiç kaynak sinyali görülmedi

    var ilkStr = duzlestir(kayit.ilk);
    var sonStr = duzlestir(kayit.son || kayit.ilk);
    var yolJson = JSON.stringify(kayit.yol.map(yolTemas));

    var imza = ilkStr + '~' + sonStr + '~' + kayit.yol.length;
    var sepet = sepetKimligi();
    if (kayit.yazilan === imza && sepet && kayit.sepet === sepet && !degisti) return;

    sepeteYaz(ilkStr, sonStr, yolJson).then(function (r) {
      if (!r || !r.ok) return null;
      return r.json().then(function (c) {
        kayit.yazilan = imza;
        kayit.sepet = String((c && c.token) || '').split('?')[0];
        yaz(depo, kayit);
      });
    }).catch(function () { /* ağ hatası — sonraki sayfada tekrar denenir */ });

    yaz(depo, kayit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', calistir, { once: true });
  } else {
    calistir();
  }
})();
